import React, { Component } from "react";
import { Container, Col, Row } from "design-react-kit";
import { NavLink } from "react-router-dom";
import { ROUTES } from "const";
import { MSection } from "components/misc";

export class DashboardIUL extends Component {
  render() {
    return (
      <>
        <h1 className="mb-4">Dashboard Segreteria IUL</h1>
        <MSection>
          <Container>
            <Row>
              <Col md={3} className="d-flex justify-content-center">
                <NavLink
                  to={ROUTES.IUL_COURSE_LIST_ONLINE}
                  className="btn btn-primary bg-dark text-white my-1"
                >
                  Calendario lezioni online
                </NavLink>
              </Col>
              <Col md={3} className="d-flex justify-content-center">
                <NavLink
                  to={ROUTES.IUL_COURSE_LIST_ONSITE}
                  className="btn btn-primary bg-dark text-white my-1"
                >
                  Calendario lezioni in presenza
                </NavLink>
              </Col>
              <Col md={3} className="d-flex justify-content-center">
                <NavLink
                  to={ROUTES.IUL_COURSE_LIST_TRAINING}
                  className="btn btn-primary bg-dark text-white my-1"
                >
                  Calendario tirocinio indiretto
                </NavLink>
              </Col>
              <Col md={3} className="d-flex justify-content-center">
                <NavLink
                  to={ROUTES.IUL_COURSE_LIST_STUDENT}
                  className="btn btn-primary bg-dark text-white my-1"
                >
                  Calendario lezioni per studente
                </NavLink>
              </Col>
            </Row>
          </Container>
        </MSection>
      </>
    );
  }
}
